module.exports = __webpack_public_path__ + "static/media/мо.7a753815.mp3";